define('config',[],function () {
	'use strict';

	var _configs = {

		debug: false,

		defaultLocale: 'zh-hk',
		
		currentLocale: 'zh-hk',
		
		ga: {
			isEnabled: false
		},

		httpService: {
			maxRetryLimit: 3,

			// retry after 2s
			retryInterval: 2000,

			// timeout after 10s
			timeoutPeriod: 10000
		},
		
		imagePlaceholder: '/static/img/placeholder.png'
	};

	var _initConfig = function () {

		var hostname = window.location.hostname;
		var pathname = window.location.pathname;
		
		if (hostname.slice(0, 5) === 'local') {

			_configs.debug = true;
		}
		
		var regex = /\/([a-z][^\/]*)\/(.*)/gi;
		var match = regex.exec(pathname);
		if(match) {
           _configs.currentLocale = match[1];
        }
	};

	var Config = function () {

		_initConfig();

		// [Elvis Chan]: get configs from server side
		var $serverConfigs = $('#app-config');

		if ($serverConfigs.length > 0) {

			_.each(window.config, function (value, key) {

				_configs[key] = value;
			});

			$serverConfigs.remove();
		}
	};

	Config.prototype = {

		get: function (key) {

			var data = (key || '').split(':');

			if (data.length === 1) {

				return _configs[key];

			} else if (data.length === 2) {

				var type = data[0];
				var name = data[1];

				return _configs[type][name];
			}
		},
	};

	return Config;
});
